const OS_LOCALE_FALLBACK_WEB_ROUTES = new Set(['/auth/post-sign-in']);

interface ShouldFallbackToOsLocaleOptions {
  isDesktop: boolean;
  pathname: string;
  routerLocale?: string;
}

/**
 * Whether the root provider must use the browser/OS locale instead of routing.
 * Keeping this decision at the root also keeps RTL layout synchronized with
 * localized text on pre-auth routes that cannot communicate their locale.
 */
export function shouldFallbackToOsLocale({
  isDesktop,
  pathname,
  routerLocale,
}: ShouldFallbackToOsLocaleOptions): boolean {
  return (
    isDesktop ||
    OS_LOCALE_FALLBACK_WEB_ROUTES.has(pathname) ||
    !routerLocale ||
    routerLocale === 'default'
  );
}
